// extracted by mini-css-extract-plugin
module.exports = {"modal":"popover_modal__nzD2o","popover":"popover_popover___FicI","open":"popover_open__EfL7c","left":"popover_left__J83u6","right":"popover_right__JSbyw"};